"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShimmerWrapper = exports.Shimmer = exports.SHIMMER_TYPE_TO_BORDER_RADIUS_MAP = exports.SHIMMER_TYPES = exports.KPIShimmer = void 0;
var React = _interopRequireWildcard(require("react"));
var _border = require("../../styles/variables/_border");
var _size = require("../../styles/variables/_size");
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _qa = require("../../utils/qa");
var _string = require("../../utils/string");
var _ShimmerModule = _interopRequireDefault(require("./Shimmer.module.css"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SHIMMER_TYPES = exports.SHIMMER_TYPES = Object.freeze({
  text: 'text',
  rounded: 'rounded',
  circular: 'circular',
  rectangular: 'rectangular'
});
const SHIMMER_TYPE_TO_BORDER_RADIUS_MAP = exports.SHIMMER_TYPE_TO_BORDER_RADIUS_MAP = Object.freeze({
  text: _border.borderRadiusXSmall,
  rounded: _border.borderRadiusMedium,
  circular: _border.borderRadiusCircle,
  rectangular: _border.borderRadiusNone
});
/**
 * Note(Nishant): ShimmerWrapper is a wrapper component for Shimmer component. This should only be used for Text based Shimmers
 * This solves a very annoying problem with out text components where the display prop is set to flex.
 * Genesis assumes that every element is flexible for simplicity and for text text shimmers to work in use cases
 * where text wraps across multiple lines, we need to wrap the shimmer in a span element.
 * to avoid the misuse where consumers use there own / other block level components, we have this wrapper.
 * This would ensure the layout remains same even when you toggle the shimmer to show your actual content
 * @param {React.Node} children - The children to be rendered
 */
const ShimmerWrapper = _ref => {
  let {
    children,
    testId
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'wrapper'
    }),
    children: children
  });
};
exports.ShimmerWrapper = ShimmerWrapper;
const Shimmer = exports.Shimmer = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    classNames,
    show = true,
    type = SHIMMER_TYPES.text,
    children,
    width = _size.size40,
    height = _size.sizeFluid,
    borderRadius,
    testId
  } = _ref2;
  if (!show) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: children
    });
  }
  const borderRadiusValue = borderRadius ?? SHIMMER_TYPE_TO_BORDER_RADIUS_MAP[type];
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    ref: ref,
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'shimmer'
    }),
    className: (0, _classify.default)(_ShimmerModule.default.wrapper, _ShimmerModule.default[type], classNames?.wrapper),
    style: {
      '--width': (0, _string.appendPx)(width),
      '--height': (0, _string.appendPx)(height),
      '--border-radius': (0, _string.appendPx)(borderRadiusValue)
    }
  });
});
const KPIShimmer = _ref3 => {
  let {
    textWidth = 150,
    hasBottomContent = true,
    hasIcon = true,
    hasTopContent = true,
    hasMiddleContent = true,
    classNames,
    testId
  } = _ref3;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    "data-testid": (0, _qa.generateTestId)({
      base: testId,
      slot: 'kpiShimmer'
    }),
    className: (0, _classify.default)(_ShimmerModule.default.kpiBox, classNames?.wrapper),
    children: [hasIcon && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: (0, _classify.default)(_ShimmerModule.default.section, _ShimmerModule.default.iconSection, classNames?.icon),
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Shimmer, {
        type: "rounded",
        width: 60,
        height: 60,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'iconShimmer'
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _classify.default)(_ShimmerModule.default.section, classNames?.text),
      children: [hasTopContent && /*#__PURE__*/(0, _jsxRuntime.jsx)(Shimmer, {
        type: "text",
        width: textWidth,
        height: 15,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'topTextShimmer'
        })
      }), hasMiddleContent && /*#__PURE__*/(0, _jsxRuntime.jsx)(Shimmer, {
        type: "text",
        width: textWidth,
        height: 25,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'middleTextShimmer'
        })
      }), hasBottomContent && /*#__PURE__*/(0, _jsxRuntime.jsx)(Shimmer, {
        type: "text",
        width: textWidth,
        height: 15,
        testId: (0, _qa.generateTestId)({
          base: testId,
          slot: 'bottomTextShimmer'
        })
      })]
    })]
  });
};
exports.KPIShimmer = KPIShimmer;